module.exports = __webpack_public_path__ + "static/media/sustainability-art-img-1@2x.31f4c618.png";